import React from "react";
import "./index.css";
import Footer from "./components/Footer";

function LoginPage({ onLogin }) {
  return (
    <>
      <div className="header" style={{ backgroundImage: "url('/assets/navbg.jpg')" }}>
        <div className="header-user">
          <div className="logoWrapper">
            <img
              src="/assets/logo.png"
              alt="user avatar"
              className="logo"
            /></div>
          <div className="line"></div>
          {/* <span className="logo-name">AI Foundry</span>
          <div className="line2"></div> */}
          <span className="logo-name">Genalytix</span>
        </div>
      </div>
      <div className="login-page">
        <div className="para">
          <p>Conversational BI & Analytics is a next Generative AI solution designed that let you explore Microsoft Fabric data using simple, natural language. Ask questions, get instant insights, and generate queries effortlessly — powered by OpenAI and the LangGraph Agentic Framework.</p>
        </div>
        <div className="login-box" >
          <button className="login-btn" onClick={onLogin}>
            Login with your organization
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LoginPage;
